import React, { FC } from "react";
import styles from "./BannerPrincipal.module.scss";
import BannerPrincipalImg from "./../../../../Static/Images/Principal/Banner.png";
import LogoVetSaude from "./../../../../Static/Images/Principal/Logo.png";
import AtendimentoCasaImg from "./../../../../Static/Images/Principal/AtendimentoCasa.png";
import ConsultasImg from "./../../../../Static/Images/Principal/Consultas.png";
import VacinaVermifugoImg from "./../../../../Static/Images/Principal/VacinaVermifugo.png";
import PlantaoImg from "./../../../../Static/Images/Principal/Plantao.png";
import { Button } from "@material-ui/core";
import { scroller } from "react-scroll";
import { isMobile } from "react-device-detect";

const BannerPrincipal: FC = () => {
  return (
    <div
      className={`${styles["BannerPrincipal"]} ${
        isMobile ? styles["mobile"] : ""
      }`}
    >
      <img
        alt="Banner"
        src={BannerPrincipalImg}
        className={styles["Banner"]}
        title="Banner"
      />

      <div className={styles["Content"]}>
        <div className={styles["Group"]}>
          <img
            alt="Vet Saúde"
            title="Vet Saúde"
            src={LogoVetSaude}
            className={styles["Logo"]}
          />
          <p className={styles["Sub-Title"]}>Seu plano de atendimento veterinário.</p>
          <p className={styles["Title"]}>
            O veterinário na sua casa, <br /> pronto para ajudar seus bichinhos
            <br />
            sempre que você precisar.
          </p>
        </div>
        <div className={styles["Group"]}>
          <div className={styles["Atendimento"]}>
            <img alt="Vet Saúde" title="Vet Saúde" src={AtendimentoCasaImg} />
            <img alt="Vet Saúde" title="Vet Saúde" src={ConsultasImg} />
            <img alt="Vet Saúde" title="Vet Saúde" src={VacinaVermifugoImg} />
            <img alt="Vet Saúde" title="Vet Saúde" src={PlantaoImg} />
          </div>
          <Button
            className={styles["ConhecaPlano"]}
            onClick={() => {
              scroller.scrollTo("planos", {
                smooth: true,
                duration: 500,
                spy: true,
              });
            }}
          >
            conheça o plano completo para o seu pet
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BannerPrincipal;
